"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeErrorMessageStyles = function (theme) {
    return (0, react_1.css)({
        fontSize: theme.mvf.fontSize.medium,
        color: theme.mvf.palette.status.error,
        maxWidth: theme.breakpoints.values.md,
        margin: '0 auto',
    });
};
exports.default = makeErrorMessageStyles;
//# sourceMappingURL=makeErrorMessageStyles.js.map